import parallaxHero from '../features/parallax-hero';
import {newsletterCheckForResultSection} from '../globals/newsletter';
import {register} from '../vendor/theme-scripts/theme-sections';

register('footer', [parallaxHero, newsletterCheckForResultSection]);
